// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1B419","title":"ClientReferral_title__2_9Yo","itemText":"ClientReferral_itemText__10iL7"};